import { LanguagesDefinition, SupportedLanguages } from 'common/services/i18nService';

export const supportedLanguages: SupportedLanguages = {
    [LanguagesDefinition.EN_US]: 'English',
    [LanguagesDefinition.NB_NO]: 'Norwegian - Bokmål',
    [LanguagesDefinition.NN_NO]: 'Norwegian - Nynorsk',
    [LanguagesDefinition.SV_SE]: 'Swedish',
    [LanguagesDefinition.NL_NL]: 'Dutch',
    [LanguagesDefinition.PL_PL]: 'Polish',
    [LanguagesDefinition.DE_DE]: 'German',
    [LanguagesDefinition.FR_FR]: 'French',
    [LanguagesDefinition.HE_IL]: 'Hebrew, Israel',
    [LanguagesDefinition.CY_GB]: 'Welsh',
    [LanguagesDefinition.IS_IS]: 'Icelandic',
    [LanguagesDefinition.FI_FI]: 'Finnish',
    [LanguagesDefinition.ES_CO]: 'Spanish',
    [LanguagesDefinition.PT_PT]: 'Portuguese',
};
